export const LOGIN_MEMBER = 'LOGIN_MEMBER';
export const LOGIN_FORM_UPDATED = 'LOGIN_FORM_UPDATED';
export const LOGIN_MEMBER_START = 'LOGIN_MEMBER_START';
export const LOGIN_MEMBER_SUCCESS = 'LOGIN_MEMBER_SUCCESS';
export const LOGOUT_MEMBER = 'LOGOUT_MEMBER';
export const LOGIN_MEMBER_ERROR = 'LOGIN_MEMBER_ERROR';
export const GET_USER_INFO = "GET_USER_INFO";
export const REGISTER_MEMBER_START = "REGISTER_MEMBER_START";
export const REGISTER_MEMBER_SUCCESS = "REGISTER_MEMBER_SUCCESS";
export const REGISTER_MEMBER_FAILURE = "REGISTER_MEMBER_FAILURE";

export const GET_MEMBER_VERIFICATION_CODE_START = "GET_MEMBER_VERIFICATION_CODE_START";
export const GET_MEMBER_VERIFICATION_CODE_SUCCESS = "GET_MEMBER_VERIFICATION_CODE_SUCCESS";
export const GET_MEMBER_VERIFICATION_CODE_FAILURE = "GET_MEMBER_VERIFICATION_CODE_FAILURE";

export const GET_USER_ID_START = "GET_USER_ID_START";
export const GET_USER_ID_SUCCESS = "GET_USER_ID_SUCCESS";
export const GET_USER_ID_FAILURE = "GET_USER_ID_FAILURE";

export const FETCH_REGION_FAILURE = "FETCH_REGION_FAILURE";
export const FETCH_REGION_START = "FETCH_REGION_START";
export const FETCH_REGION_SUCCESS = "FETCH_REGION_SUCCESS";

export const GET_REGIONS_LIST_FAILURE = "GET_REGIONS_LIST_FAILURE";

export const GET_STATE_AND_CITIES_START = "GET_STATE_AND_CITIES_START";
export const GET_STATE_AND_CITIES_FAILURE = "GET_STATE_AND_CITIES_FAILURE";
export const GET_STATE_AND_CITIES_SUCCESS = "GET_STATE_AND_CITIES_SUCCESS";

export const GET_REGIONS_LIST_SUCCESS = "GET_REGIONS_LIST_SUCCESS";
export const RESET_STATE_AND_CITIES = "RESET_STATE_AND_CITIES";
export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";

export const USER_REGISTRATION_FAILURE = "USER_REGISTRATION_FAILURE";
export const USER_REGISTRATION_START = "USER_REGISTRATION_START";
export const USER_REGISTRATION_SUCCESS = "USER_REGISTRATION_SUCCESS";

export const REGION_MARKERS_LIST = "REGION_MARKERS_LIST";

export const GET_EMAIL_ID_VERIFY_FAILURE = "GET_EMAIL_ID_VERIFY_FAILURE";
export const GET_EMAIL_ID_VERIFY_START = "GET_EMAIL_ID_VERIFY_START";
export const GET_EMAIL_ID_VERIFY_SUCCESS = "GET_EMAIL_ID_VERIFY_SUCCESS";

export const SET_REDIRECT_URI_START = "SET_REDIRECT_URI_START";
export const SET_REDIRECT_URI_SUCCESS = "SET_REDIRECT_URI_SUCCESS";

export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";

export const MEMBER_LOGIN_REDIRECT_START = "MEMBER_LOGIN_REDIRECT_START";
export const MEMBER_LOGIN_REDIRECT_SUCCESS = "MEMBER_LOGIN_REDIRECT_SUCCESS";
export const MEMBER_LOGIN_REDIRECT_FAILURE = "MEMBER_LOGIN_REDIRECT_FAILURE";

export const MEMBER_AUTHENTICATION_START = "MEMBER_AUTHENTICATION_START";
export const MEMBER_AUTHENTICATION_SUCCESS = "MEMBER_AUTHENTICATION_SUCCESS";
export const MEMBER_AUTHENTICATION_FAILURE = "MEMBER_AUTHENTICATION_FAILURE";

export const VERIFY_TOKEN_START = "VERIFY_TOKEN_START";
export const VERIFY_TOKEN_SUCCESS = "VERIFY_TOKEN_SUCCESS";
export const VERIFY_TOKEN_FAILURE = " VERIFY_TOKEN_FAILURE";

export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";

export const GET_MEMBER_DETAILS_FAILURE = "GET_MEMBER_DETAILS_FAILURE";
export const GET_MEMBER_DETAILS_START = "GET_MEMBER_DETAILS_START";
export const GET_MEMBER_DETAILS_SUCCESS = "GET_MEMBER_DETAILS_SUCCESS";

export const MEMBER_VALIDATION_FAILURE = "MEMBER_VALIDATION_FAILURE";
export const MEMBER_VALIDATION_START = "MEMBER_VALIDATION_START";
export const MEMBER_VALIDATION_SUCCESS = "MEMBER_VALIDATION_SUCCESS";


export const GET_AUTH_CODE_START = "GET_AUTH_CODE_START";
export const GET_AUTH_CODE_SUCCESS = "GET_AUTH_CODE_SUCCESS";
export const GET_AUTH_CODE_FAILURE = "GET_AUTH_CODE_FAILURE";

export const EMAIL_VERIFICATION_START = "EMAIL_VERIFICATION_START"
export const EMAIL_VERIFICATION_SUCCESS = "EMAIL_VERIFICATION_SUCCESS"
export const EMAIL_VERIFICATION_FAILURE = " EMAIL_VERIFICATION_FAILURE"
export const GET_EMAIL_VERIFICATION_CODE_START = "GET_EMAIL_VERIFICATION_CODE_START"
export const GET_EMAIL_VERIFICATION_CODE_SUCCESS = "GET_EMAIL_VERIFICATION_CODE_SUCCESS"
export const GET_EMAIL_VERIFICATION_CODE_FAILURE = "GET_EMAIL_VERIFICATION_CODE_FAILURE"

export const RESET_REDIRECT_URL = "RESET_REDIRECT_URL";